import { UUID } from '../uuid';

/** Standard relative CRUD endpoint paths, appended to a feature's base endpoint. */
export const crud = () => ({
  getAll: () => '',
  getById: (id: UUID) => id,
  getByIds: () => 'ids',
  create: () => '',
  update: () => '',
  delete: (id: UUID) => id,
  findAllFiltered: () => 'filter',
});
